let form = {
  "labels": {
    "title": "Title",
    "description": "Description",
    "phone": "Phone number",
    "email": "Email address",
    "address": "Address",
    "product": "Product",
    "product_title": "Title",
    "quantity": "Quantity",
    "price": "Price",
    "price_type": "Unit",
    "price_per_unit": "Price per unit",
    "vat_option": "VAT",
    "total": "Total",
    "name": "Name",
    "first_and_last_name": "First and last name",
    "honorific": "Civility",
    "phone_number": "Phone number",
    "address_line_1": "Address line 1",
    "address_line_2": "Address line 2",
    "postal_code": "Postal code",
    "city": "City",
    "country": "Country",
    "comments": "Comments",
    "is_professional": "Professional client",
    "vat_number": "VAT number",
    "vat_option_id": "VAT",
    "default_vat_option_id": "default VAT",
    "category_id": "Category",
    "price_type_id": "Unit",
    "percentage": "Percentage",
    "payment_date": "Expiry date",
    "payment_communication": "Payment instruction",
    "valid_until": "Validity date",
    "paid_at": "Date of payment",
    "discount": "Discount",
    "subject": "Subject",
    "email_subject": "Subject of the email",
    "email_text": "Text of the email",
    "email_to": "Recipient",
    "email_copy": "Send me a copy by email",
    "status": "Status",
    "amount": "Amount",
    "company_name": "Company name",
    "company_email": "Email address",
    "company_phone_number": "Phone number",
    "company_vat": "VAT number",
    "company_vat_number": "VAT number",
    "company_address_line_1": "Address line 1",
    "company_address_line_2": "Address line 2",
    "company_postal_code": "Postal code",
    "company_city": "City",
    "company_country": "Country",
    "company_logo": "Logo",
    "client_id": "Customer",
    "client_name": "Customer name",
    "client_email": "Email address",
    "client_phone_number": "Phone number",
    "client_vat_number": "VAT number",
    "client_address_line_1": "Address line 1",
    "client_address_line_2": "Address line 2",
    "client_postal_code": "Postal code",
    "client_city": "City",
    "client_country": "Country",
    "client_reminder_1_enabled": "Enable the first callback level for this customer",
    "client_reminder_2_enabled": "Enable the second callback level for this client",
    "client_reminder_3_enabled": "Enable the third level of callback for this client",
    "invoice_title": "Reference",
    "invoice_files": "Related files",
    "invoice_number_prefix": "Prefix",
    "invoice_number_prefix_custom": "Custom prefix",
    "current_year": "Year",
    "invoice_number_format": "Format",
    "invoice_number_demo": "Example",
    "invoice_number_starts_at": "Start of numbering",
    "invoice_number_starts_at_year": "Apply this numbering to the year",
    "invoice_number_starts_at_month": "Apply this numbering to the month",
    "invoice_send_email_subject": "Subject of the email",
    "invoice_send_email_text": "Text of the email",
    "invoice_send_email_copy": "Send me a copy by email",
    "invoice_payment_delay": "Default payment term",
    "invoice_payment_delay_type": null,
    "invoice_iban_number": "IBAN",
    "invoice_bic": "BIC",
    "invoice_payment_communication_type": "Type of communication",
    "invoice_number": "Invoice number",
    "structured_communication": "Structured Communication",
    "invoice_payment_communication_type_custom": "Personalized communication",
    "invoice_payment_communication": "Default payment instruction",
    "invoice_extra_pdf": "PDF",
    "invoice_display_custom_start": "Change the beginning of the numbering",
    "quote_decline_reason": "Reason for declination",
    "quote_validity_delay": "Default validity period",
    "quote_conditions": "Conditions of the quote",
    "reminder_enabled": "Activate this reminder level",
    "reminder_value": "Days after due date",
    "reminder_email_subject": "Subject of the email",
    "reminder_email_text": "Text of the email",
    "reminder_email_copy": "Send me a copy of this email",
    "display_primary_color": "Main color",
    "display_secondary_color": "Secondary color",
    "card_number": "Card number",
    "card_expiry": "Expiry date",
    "card_cvv": "CVV",
    "cocontractor": "VAT Co-contractor",
    "next_invoice_number": "Invoice number",
    "next_quote_number": "Quote number",
    "next_credit_note_number": "Credit note number",
    "record_payment_predefined_title": "Title",
    "record_payment_custom_title": "Title",
    "invoice_template": "Sample document",

    image_uploader_button: 'Upload an image...',
    image_uploader_button_multiple: 'Upload images...',
    image_uploader_button_more: "Upload another image...",
    image_uploader_button_more_multiple: "Upload more images...",
    image_uploader_button_replace: "Upload to replace the image...",
    image_uploader_button_replace_multiple: "Upload to replace the images...",

    file_uploader_button: 'Upload a file',
    file_uploader_button_multiple: 'Upload files',
    file_uploader_button_selected: "File selected",
    file_uploader_button_selected_multiple: "One file selected | {count} files selected",
    contacts: {
      title: "Contact",
      types: "Contact type",
      name: "Contact name"
    }
  },
  "placeholders": null,
  "messages": {
    "image_uploader_confirm_image_replacement": "Are you sure you want to replace the current image?",
    "image_uploader_wrong_image_type": "The file format is not valid as an image."
  },
  "buttons": {
    "create": "Create",
    "edit": "Edit"
  },
  "variables": {
    "invoicenumber": "Invoice number",
    "quotenumber": "Quote number",
    "creditnotenumber": "Credit note number",
    "communication": "Communication",
    "invoiceamount": "Amount of the invoice",
    "quoteamount": "Amount of the estimate",
    "creditnoteamount": "Amount of the credit note",
    "invoiceremainingamount": "Remaining balance of the invoice",
    "creditnoteremainingamount": "Remaining balance of the credit note",
    "iban": "IBAN",
    "bic": "BIC",
    "invoicedate": "Date of invoice",
    "quotedate": "Date of quotation",
    "creditnotedate": "Date of credit note",
    "duedate": "Expiry date",
    "validitydate": "Validity date",
    "companyname": "Company"
  },
  "options": {
    "invoice_number_prefix": {
      "none": "No prefix",
      "custom": "Custom prefix",
      "year": "Current year",
      "year2": "Current year (last two digits)"
    },
    "invoice_number_format": {
      "1": "One figure",
      "2": "Two figures",
      "3": "Three figures",
      "4": "Four figures",
      "5": "Five figures"
    },
    "invoice_number_starts_at_month": {
      "1": "January",
      "2": "February",
      "3": "March",
      "4": "April",
      "5": "May",
      "6": "June",
      "7": "July",
      "8": "August",
      "9": "September",
      "10": "October",
      "11": "November",
      "12": "December",
      "none": "Do not use a custom start per month"
    },
    "invoice_payment_delay_type": {
      "sent": "Days to invoice date",
      "month": "Month-end days"
    },
    "invoice_payment_communication_type": {
      "invoice_number": "Invoice number",
      "structured_communication": "Structured communication",
      "custom": "Personalized"
    },
    "quote_validity_delay_type": {
      "sent": "Days quote date"
    },
    "record_payment_title": {
      "total_payment": "Payment of the balance",
      "down_payment": "Advance payment",
      "partial_payment": "Partial payment",
      "other": "Other"
    },
    "invoice_template": {
      "default": "Classic",
      "tiny": "Tiny",
      "condensed": "Condensed",
      "flat-out": "Flat out"
    }
  },
  "helpers": {
    "cocontractor": "Will show \"* Reverse Charge\" on documents containing one or more items with this VAT rate."
  }
};

form.placeholders = form.labels;
form.placeholders.select = 'Choose an option';

export default form;